<div class="relative flex flex-col p-3 md:p-5 gap-3 overflow-x-hidden">
  <div class="w-full absolute">
    <button
      class="border-none outline-none w-auto mb-4"
      aria-hidden="false"
      [mat-dialog-close]="false">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @switch (view) {
    @case (ProfileViewEnum.INFO) {
      <qaroni-account-info
        (changeView)="changeView($event)"
        [account]="account" />
    }
    @case (ProfileViewEnum.EDIT) {
      <qaroni-account-edit
        (changeView)="changeView($event)"
        [account]="account" />
    }
    @case (ProfileViewEnum.PASSWORD) {
      <qaroni-account-reset-password
        (changeView)="changeView($event)"
        (closeProfile)="close()" />
    }
    @default {
      <qaroni-account-info
        (changeView)="changeView($event)"
        [account]="account" />
    }
  }
</div>
